import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
  sequence
} from '@angular/animations';

export function Collapse(duration: number = 300) {
  return trigger('collapse', [
    state(
      'void',
      style({
        height: '0',
        opacity: '0',
        overflow: 'hidden'
      })
    ),
    state(
      '*',
      style({
        height: '*',
        opacity: '1'
      })
    ),
    transition('true <=> false', [
      style({ overflow: 'hidden' }), // Set overflow as a static style, not animated
      animate(`${duration}ms ease-in-out`)
    ])
  ]);
}
